import angular from 'angular'
import routers from './routers.js'
import smallScaleReportQueryCtrl from './smallScaleReportQueryCtrl'

export default angular
  .module('declaration.addValTaxSmallScale.smallScaleReportQuery', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('smallScaleReportQueryCtrl', smallScaleReportQueryCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/smallScaleReportQuery/index.js